import L from "@/plugins/leaflet";

import "./ButtonControl.css";

export const ButtonControl = L.Control.extend({
  /**
   *
   * @param {string} title
   * @param {string} icon Material Icon Name https://material.io/resources/icons
   * @param {string} className additional class name
   * @param {Function} onClick
   * @param {Object} options
   */
  initialize: function(title, icon, className, onClick, options) {
    L.setOptions(this, options);
    this.title = title;
    this.icon = icon;
    this.className = className;
    this.onClick = onClick;
  },

  onAdd(map) {
    this._map = map;

    // Icon
    const icon = document.createElement("i");
    icon.className = "v-icon material-icons";
    icon.ariaHidden = true;
    icon.style.fontSize = "1.125em";
    icon.style.lineHeight = "2.025em";
    icon.innerText = this.icon;

    // Button
    this._container = document.createElement("a");
    this._container.className = this.className || "";
    this._container.href = "#";
    this._container.role = "button";
    this._container.title = this.title;
    this._container.ariaLabel = this.title;

    this._container.onclick = () => {
      if (this.onClick instanceof Function) {
        this.onClick();
      }
    };

    this._container.append(icon);

    return this._container;
  },

  changeIcon(icon) {
    this.icon = icon;

    this._container.firstElementChild.innerText = this.icon;
  },

  setEnable(val) {
    this._container.disabled = !val;
  },

  setLoading(loading) {
    if (loading) {
      this._container.firstElementChild.innerText = "loop";
      this._container.firstElementChild.classList.add("spinning");
      this.setEnable(false);
    } else {
      this._container.firstElementChild.innerText = this.icon;
      this._container.firstElementChild.classList.remove("spinning");
      this.setEnable(true);
    }
  }
});
